import {
  Article,
  ArticleSubtitle,
  ArticleTitle,
} from "@babackapp/customer-ui/components/article";
import { DiscountedPrice } from "@babackapp/return-widget-components/components/discounted-price";
import { getLineItemDisplay } from "@babackapp/return-widget-components/utils/line-item-display";
import type {
  DraftLineItem,
  Order,
  OrderLineItem,
} from "@babackapp/return-widget-components/types";
import { ExchangeArticleImage, getExchangeArticle } from "./exchange-article";

type Props = {
  item: DraftLineItem;
  orderLineItems: OrderLineItem[];
  order: Order | null;
  currency: string;
};

export function CompleteReturnLineItem({
  item,
  orderLineItems,
  order,
  currency,
}: Props) {
  const display = getLineItemDisplay(orderLineItems, item.lineItemId);
  const { title, image, price, paidPrice } = display;

  const { variantDisplay, exchangeTitle, exchangeImage } = getExchangeArticle(
    order,
    item,
    display,
  );

  return (
    <Article>
      <ExchangeArticleImage
        src={image}
        exchangeSrc={exchangeImage}
        exchangeAlt={exchangeTitle ?? title}
        layoutId={`img-complete-${item.lineItemId}`}
      />
      <ArticleTitle>
        {title}
        {exchangeTitle && (
          <span className="font-normal text-muted-foreground">
            {" "}
            → {exchangeTitle}
          </span>
        )}
      </ArticleTitle>
      <ArticleSubtitle>
        {variantDisplay && `${variantDisplay} · `}×{item.quantity}
        {!!price && (
          <>
            {" · "}
            <DiscountedPrice
              catalogCents={price}
              paidCents={paidPrice}
              quantity={item.quantity}
              currency={currency}
            />
          </>
        )}
      </ArticleSubtitle>
    </Article>
  );
}
